import { Entity, Scene } from "nopun-ecs";
import { Sprite } from "pixi.js";
import { Polygon } from "detect-collisions";

import { CollisionShape, PIXIContainerRef, Position2D, Velocity2D } from "../../component";
import { addBulletToScene } from "../Bullet";

import image from "./Player.png";

export class Player {
}

export function addPlayerToScene(scene: Scene): Entity {
    const sprite = Sprite.from(image);
    const width = 84;
    const height = 72;

    sprite.pivot.set(width/2, height/2);

    return scene.entities.create()
        .add(Player)
        .add(CollisionShape, { body: new Polygon(0, 0, [
            [-width/2, -height/2],
            [width/2, 0],
            [-width/2, height/2]]
        )})
        .add(PIXIContainerRef, { current: sprite })
        .add(Position2D, { x: window.innerWidth/2, y: window.innerHeight/2 })
        .add(Velocity2D, { angle: 0, speed: 0 });
}

export function shootBullet(player: Entity): void {
    const position = player.get(Position2D);
    const velocity = player.get(Velocity2D);

    addBulletToScene(player.scene)
        .add(Position2D, { ...position })
        .update(Velocity2D, { angle: velocity.angle });
}